/**
 * Russian pluralization for "N игрок / игрока / игроков"-style suffixes.
 * Handles teen exceptions (11..14 always take the "many" form).
 *
 * Lives in its own module so unit tests can import it without dragging in
 * DOM/window dependencies via TonPreviewScreen.
 */
export function pluralRu(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n)
  const mod10 = abs % 10
  const mod100 = abs % 100
  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few
  return many
}
